import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./components/HomePage";
import About from "./components/About";
import Service from "./components/Service";
import GeneralService from "./components/GeneralService";
import PerContruction from "./components/PerContruction";
import RenovationRemodeling from "./components/RenovationRemodeling";
import CivilConstructionServices from "./components/CivilConstructionServices";
import ProjectManagement from "./components/ProjectManagement";
import SustainableGreenConstruction from "./components/SustainableGreenConstruction";
import Contact from "./components/Contact";
import Travel from "./components/Travel";
import Counters from "./components/counters";
import NavBar from "./components/navbar";
import ServiceDetails from "./components/ServiceDetails";
import AreaCalculator from "./components/AreaCalculator";
import OutGallery from "./components/OurGallery";

function App() {
  return (
    <Router>
      <Header />
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route path="/about" component={About} />
        <Route path="/service" component={Service} />
        <Route path="/general-service" component={GeneralService} />
        <Route path="/perContruction" component={PerContruction} />
        <Route path="/renovation-remodeling" component={RenovationRemodeling} />
        <Route path="/civil-construction-services" component={CivilConstructionServices} />
        <Route path="/project-management" component={ProjectManagement} />
        <Route path="/sustainable-green-construction" component={SustainableGreenConstruction} />
        <Route path="/contact" component={Contact} />
        <Route path="/travel" component={Travel} />
        <Route path="/counters" component={Counters} />
        <Route path="/navbar" component={NavBar} />
        <Route path="/ourGallery" component={OutGallery} />
        <Route path="/serviceDetails/:id" component={ServiceDetails} />
        <Route path="/calculator" component={AreaCalculator} />
      </Switch>
      <Footer />
    </Router>
  );
}

export default App;
